export enum DeliverableOrderTypes {
  FOODSPOT = 'foodspot',
  DELIVERY = 'delivery',
}
